module.exports = __webpack_public_path__ + "img/рз_16.d28fd2f2.png";